import { Component, OnInit } from '@angular/core';
import {environment} from '@env/environment';
import {Store} from '@ngxs/store';
import {ServiceInfoState, ServiceInfo} from '@app/state/service-info.state';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit {

  appVersion: string;
  serviceInfo: ServiceInfo;

  constructor(
    private store: Store,
  ) {
    this.listenStoreChanges();
  }

  ngOnInit(): void {
    this.appVersion = environment.appVersion;
  }


  private listenStoreChanges() {
    this.store.select(ServiceInfoState).subscribe((serviceInfo: ServiceInfo) => {
      this.serviceInfo = serviceInfo;
    });
  }
}
